"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BodyRow_1 = require("./BodyRow");
var GridSelection_1 = require("./GridSelection");
var Utils_1 = require("./Utils");
var BodySection = /** @class */ (function (_super) {
    __extends(BodySection, _super);
    function BodySection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line
        _this.state = { hoverRow: null };
        _this.handleMouseEnter = function (row) {
            _this.setState({ hoverRow: row });
        };
        _this.handleMouseLeave = function () {
            _this.setState({ hoverRow: null });
        };
        _this.handleReportCellWidthFn = function (columnKey, width) {
            if (_this.props.measureColumnWidths && _this.props.measuredColumnWidths[columnKey] === undefined) {
                _this.measuredColumnWidths[columnKey] = Math.max(width, _this.measuredColumnWidths[columnKey] || 0);
            }
        };
        return _this;
    }
    BodySection.prototype.componentWillMount = function () {
        this.measuredColumnWidths = {};
    };
    BodySection.prototype.componentDidMount = function () {
        this.reportMeasuredColumnWidths();
    };
    BodySection.prototype.componentDidUpdate = function () {
        this.reportMeasuredColumnWidths();
    };
    BodySection.prototype.reportMeasuredColumnWidths = function () {
        if (this.props.measureColumnWidths && Object.keys(this.measuredColumnWidths).length > 0) {
            var measuredColumnWidths = Utils_1.assign({}, this.measuredColumnWidths);
            this.measuredColumnWidths = {};
            this.props.measureColumnWidths(measuredColumnWidths);
        }
    };
    BodySection.prototype.isRowSelected = function (row, rowIdx) {
        if (!row || !this.props.selectionData) {
            return false;
        }
        if (this.props.isSelectionDataIndexBased) {
            return GridSelection_1.GridSelection.isRowSelected(rowIdx, this.props.selectionData);
        }
        else {
            return Utils_1.has(this.props.selectionData, row.key);
        }
    };
    BodySection.prototype.render = function () {
        // tslint:disable-next-line:no-any
        var rowElements = [];
        for (var i = this.props.rowStartIdx; i < this.props.rowEndIdx; i++) {
            var row = this.props.rows[i];
            var isRowSelected = this.isRowSelected(row, i);
            rowElements.push(BodyRow_1.BodyRow.element({
                key: i,
                row: row,
                rowIdx: i,
                colStartIdx: this.props.colStartIdx,
                colEndIdx: this.props.colEndIdx,
                cols: this.props.cols,
                columnWidths: this.props.columnWidths,
                rowStylist: this.props.rowStylist,
                onCellClick: this.props.onCellClick,
                onCellDoubleClick: this.props.onCellDoubleClick,
                onCellContextMenu: this.props.onCellContextMenu,
                onRowClick: this.props.onRowClick,
                isSelected: isRowSelected,
                selectionData: this.props.selectionData,
                isSelectionDataIndexBased: this.props.isSelectionDataIndexBased,
                isHovered: row && (this.state.hoverRow === row),
                isFocused: row && i === this.props.focusedRowIndex,
                showRowHeaders: this.props.showRowHeaders,
                showHorizontalGridLines: this.props.showHorizontalGridLines,
                showVerticalGridLines: this.props.showVerticalGridLines,
                leftMargin: this.props.leftMargin,
                handleMouseEnter: this.handleMouseEnter,
                handleMouseLeave: this.handleMouseLeave,
                measuredColumnWidths: this.props.measuredColumnWidths,
                reportWidthFn: this.handleReportCellWidthFn,
                rowOuterHeight: this.props.rowOuterHeight
            }));
        }
        return (React.createElement("div", { className: 'tb-react-dg-bsection' }, rowElements));
    };
    BodySection.displayName = 'DataGridBodySection';
    BodySection.element = React.createFactory(BodySection);
    return BodySection;
}(React.PureComponent));
exports.BodySection = BodySection;
//# sourceMappingURL=BodySection.js.map